<template>
  <a-badge class="badge" :count="count" />
</template>


<script>
export default {
  name: 'Badge',
  props: {
    count: {
      type: Number,
      default: 0
    }
  },
}
</script>

<style lang="less" scoped>
.badge {
  /deep/ .ant-badge-count {
    box-shadow: none;
  }
}
</style>